import { UserCommentsService } from '@fair-play/infra';
import { inject } from '@angular/core';
import { AddCommentCommandPayload } from './add-comment.command-payload';
import { CreateUserCommentDto } from '@core-http';
import { Observable } from 'rxjs';

export class AddCommentCommandHandler {
  private readonly userCommentsService: UserCommentsService = inject(UserCommentsService);

  addComment(payload: AddCommentCommandPayload): Observable<void> {
    const dto: CreateUserCommentDto = this.mapToDto(payload);
    return this.userCommentsService.addComment(dto);
  }

  private mapToDto(payload: AddCommentCommandPayload): CreateUserCommentDto {
    return {
      userId: payload.userId,
      gameId: payload.gameId,
      commentType: payload.commentType
    };
  }
}
